











































import Vue from "vue";
import moment from "moment";
import Web3 from "web3";
import { setIntervalAsync, clearIntervalAsync, SetIntervalAsyncTimer } from "set-interval-async/fixed";

export default Vue.extend({
  name: "DxsaleDisableWhitelistMonitor",

  data: () => ({
    dialog: false as boolean,
    isStarted: false as boolean,
    btnColor: "primary" as string,
    btnText: "Start" as string,
    foundTime: " " as string,
    transactionHash: " " as string,
    transactionHashLink: "" as string,
    interval: undefined as undefined | SetIntervalAsyncTimer,
  }),
  methods: {
    async click(): Promise<void> {
      if (this.isStarted) {
        if (this.interval != undefined) {
          await clearIntervalAsync(this.interval);
        }
        this.transactionHash = " ";
        this.transactionHashLink = "";
        this.btnColor = "primary";
        this.btnText = "Start";
        this.isStarted = false;
        return;
      }

      this.foundTime = " ";
      this.transactionHash = " ";
      this.transactionHashLink = "";

      const web3 = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed1.defibit.io:443"));
      web3.extend({
        property: "txpool",
        methods: [
          {
            name: "content",
            call: "txpool_content",
          },
        ],
      });

      this.isStarted = true;
      this.btnColor = "secondary";
      this.btnText = "Stop";

      // transaction の監視を開始
      const checkedTransactionHashs: string[] = [];
      this.interval = setIntervalAsync(async () => {
        const result = await (web3 as any).txpool.content();
        const pendingTransactions: any[] = Object.values(result.pending);
        outerLoop: for (const pendingTransaction of pendingTransactions) {
          const transactions: any[] = Object.values(pendingTransaction);
          for (const transaction of transactions) {
            if (transaction == null || checkedTransactionHashs.includes(transaction.hash)) {
              continue;
            }
            if (transaction.to == "0x560560ea09b3b8ec6d139564f143778361df2827".toLowerCase()) {
              const methodSignature = transaction.input.slice(0, 10);
              const last = transaction.input.slice(-1);
              if (methodSignature == "0x8957bd67" && last == "1") {
                this.foundTime = `${moment().format("YYYY/MM/DD HH:mm:ss")}`;
                this.transactionHash = transaction.hash;
                this.transactionHashLink = `https://bscscan.com/tx/${this.transactionHash}`;

                this.btnColor = "primary";
                this.btnText = "Start";
                this.isStarted = false;
                this.dialog = true;

                if (this.interval != undefined) {
                  await clearIntervalAsync(this.interval);
                }

                break outerLoop;
              }
            }
          }
        }
        if (checkedTransactionHashs.length > 20000) {
          const deleteCount = checkedTransactionHashs.length - 20000;
          checkedTransactionHashs.splice(0, deleteCount);
        }
      }, 10);
    },
  },
});
